import { Typography } from '@mui/material';

const Copyright = ({ year = new Date().getFullYear() }: { year?: number }) => (
  <Typography variant="body2" color="textSecondary" align="center">
    {'Copyright © GMD '}
    {year}
    {'.'}
  </Typography>
);

export default Copyright;
